export const CALL_EMAIL_TEMPLATE = 'CALL_EMAIL_TEMPLATE';
export const FETCH_ALL_EMAIL_TEMPLATE = 'FETCH_ALL_EMAIL_TEMPLATE';
export const CALL_SMS_TEMPLATE = 'CALL_SMS_TEMPLATE';
export const FETCH_ALL_SMS_TEMPLATE = 'FETCH_ALL_SMS_TEMPLATE';

const setCallEMAILTemplate = data =>
({
    type: CALL_EMAIL_TEMPLATE,
    payload: { data },
});

const setGetAllEMAILTemplate = data =>
({
    type: FETCH_ALL_EMAIL_TEMPLATE,
    payload: { data },
});

const setCallSMSTemplate = data =>
({
    type: CALL_SMS_TEMPLATE,
    payload: { data },
});

const setGetAllSMSTemplate = data =>
({
    type: FETCH_ALL_SMS_TEMPLATE,
    payload: { data },
});


//GET FROM DISPATCH
export const callSMSTemplate = data => async dispatch => {
    try {
        dispatch(setCallSMSTemplate(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAllSMSTemplate = data => dispatch => {
    dispatch(setGetAllSMSTemplate(data));
};

export const callEmailTemplate = data => async dispatch => {
    try {
        dispatch(setCallEMAILTemplate(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAllEmailTemplate = data => dispatch => {
    dispatch(setGetAllEMAILTemplate(data));
};
